import React from 'react';
import article from '../Modules/Article';
import {baseUrl} from '../actions/config';
import Helmet from 'react-helmet';
import apiConsts from '../libs/api-consts';

function validateImageSrc(imaTag) {
  const regex = /"((https|http):)?(\/.*\.\w{3})"/g;
  let m;
  let valid = false;
  while ((m = regex.exec(`${imaTag}`)) !== null) {
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    valid = true;
  }
  return valid;
}

function validateContent(content) {
  const imgRegex = /<img([\w\W]+?)\/>/g;
  let imgResults;

  while ((imgResults = imgRegex.exec(content)) !== null) {
    if (imgResults.index === imgRegex.lastIndex) {
      imgRegex.lastIndex++;
    }

    const image = imgResults[0].replace('http://', 'https://');
    const valid = validateImageSrc(image);
    if (!valid) {
      content = content.replace(image, '');
    } else {
      content = content.replace(imgResults[0], image);
    }
  }
  return content;
}

/* eslint-disable */
const getContent = function (content) {
  const cleanContent =  validateContent(content);
  return <div dangerouslySetInnerHTML={{__html: cleanContent}}/>;
};
/* eslint-enable */

function parseItemsContent(items) {
  return items.map((item, index) => article(item, index));
}

function getBaseUrl() {
  return (typeof window !== 'undefined' && window.fullPath) || baseUrl.get();
}

function getAPIBaseUrl() {
  return (typeof window !== 'undefined' && window.relPath) || '/';
}

function reportBi(evid, params = '') {
  const img = document.createElement('img');
  img.src = `//frog.wix.com/updates?src=19&evid=${evid}${params ? `&${params}` : params}`;
}

function validTwoCharDate(date) {
  return date.toString().length !== 2 ? `0${date}` : date;
}

function buildDateFormat(timestamp) {
  const date = new Date(timestamp);
  const YYYY = date.getUTCFullYear();
  const MM = validTwoCharDate(date.getUTCMonth() + 1);
  const DD = validTwoCharDate(date.getUTCDate());
  const HH = validTwoCharDate(date.getUTCHours());
  const MMinutes = validTwoCharDate(date.getUTCMinutes());
  const SS = validTwoCharDate(date.getUTCSeconds());
  return `${YYYY}-${MM}-${DD}T${HH}:${MMinutes}:${SS}`;
}

function getHelemt(seo) {
  return (<Helmet
    title={seo.title}
    meta={[
      {property: 'description', content: `${seo.description}`},
      {property: 'og:title', content: `${seo.title}`},
      {property: 'og:description', content: `${seo.description}`}
    ]}
    />);
}

function getCookieProp(prop) {
  const cookieProps = document.cookie.split('; ');
  const cookie = {};
  for (let i = 0; i < cookieProps.length; i++) {
    const keyValue = cookieProps[i].split('=');
    cookie[keyValue[0]] = keyValue[1];
  }
  return cookie[prop];
}

function isUserSessionValid() {
  return getCookieProp('userType') === 'REGISTERED';
}

function redirectToLogin(toPage) {
  const myUrl = `${window.basePath}/${toPage}`;
  const loginUrl = `https://users.wix.com/signin?postLogin=${encodeURIComponent(myUrl)}&postSignUp=${encodeURIComponent(myUrl)}`;
  window.location = loginUrl;
}

function generatePostDate(date) {
  return `${date.month} ${date.day}, ${date.year}`;
}

function getDaysRange(forPastDays) {
  const time = new Date().getTime();
  return {
    end: time,
    start: time - (1000 * 60 * 60 * 24 * forPastDays)
  };
}

function dateFixSpecialChars(dateString) {
  return dateString.replace(/-/g, '/');
}

function dateFromString(dateString) {
  const date = dateString.split('/').map(number => parseInt(number, 10));
  return new Date(date[2], date[0] - 1, date[1]).getTime();
}

function getMonth(date) {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return months[date.getMonth()];
}

function generateDate(timestamp) {
  const tempDate = new Date(timestamp);
  return {
    month: getMonth(tempDate),
    day: tempDate.getDate(),
    year: tempDate.getFullYear()
  };
}

function getAbsoluteLink(link) {
  const protocol = typeof location !== 'undefined' && location.protocol.indexOf('http') !== -1 ? location.protocol : 'http:';
  return `${protocol}${apiConsts.socialBasePath}${link}`;
}

export default {getAbsoluteLink, generateDate, getContent, dateFromString, parseItemsContent, dateFixSpecialChars, generatePostDate, getBaseUrl, getAPIBaseUrl, reportBi, getHelemt, isUserSessionValid, redirectToLogin, buildDateFormat, getDaysRange};



// WEBPACK FOOTER //
// ./utils/utils.js